import { render, staticRenderFns } from "./supplement.vue?vue&type=template&id=be1fc504&scoped=true"
import script from "./supplement.vue?vue&type=script&lang=js"
export * from "./supplement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1fc504",
  null
  
)

export default component.exports